import type { FC, ReactNode } from 'react'
import type { ProductSummary } from '@/types'

import { cn } from '@/lib/utils'
import { ProductCard } from '@/components/catalog/product-card'

interface ProductGridProps {
    products: ProductSummary[]
    columns?: 3 | 4
    className?: string
}

export const ProductGrid: FC<ProductGridProps> = ({ products, columns = 4, className }): ReactNode => {
    return (
        <ul
            className={cn(
                'grid grid-cols-1 gap-x-6 gap-y-12 min-[480px]:grid-cols-2',
                columns === 4 ? 'lg:grid-cols-3 xl:grid-cols-4' : 'lg:grid-cols-3',
                className
            )}
        >
            {products.map((product) => (
                <li key={product.id} className='flex'>
                    <ProductCard product={product} className='w-full' />
                </li>
            ))}
        </ul>
    )
}
